import { render, staticRenderFns } from "./Hydroelectricpowerstations.vue?vue&type=template&id=578c3810&scoped=true&"
import script from "./Hydroelectricpowerstations.vue?vue&type=script&lang=js&"
export * from "./Hydroelectricpowerstations.vue?vue&type=script&lang=js&"
import style0 from "./Hydroelectricpowerstations.vue?vue&type=style&index=0&id=578c3810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578c3810",
  null
  
)

export default component.exports